class ExpectedDelivery extends HTMLElement {
  connectedCallback() {
    const dates = this.querySelector('#expected-delivery');
    if (!(dates instanceof HTMLElement)) return;

    const min = Number(dates.dataset.min || 0);
    const max = Number(dates.dataset.max || min);
    const includeSaturday = dates.dataset.saturday === 'true';
    const includeSunday = dates.dataset.sunday === 'true';
    const start = new Date();
    const firstDate = this.deliveryDate(start, Math.min(min, max), includeSaturday, includeSunday);
    const lastDate = this.deliveryDate(start, Math.max(min, max), includeSaturday, includeSunday);
    const format = new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
      month: 'short',
      day: 'numeric',
    });

    dates.textContent =
      firstDate.toDateString() === lastDate.toDateString()
        ? format.format(firstDate)
        : `${format.format(firstDate)} - ${format.format(lastDate)}`;
  }

  /**
   * @param {Date} start
   * @param {number} days
   * @param {boolean} includeSaturday
   * @param {boolean} includeSunday
   * @returns {Date}
   */
  deliveryDate(start, days, includeSaturday, includeSunday) {
    const date = new Date(start);
    date.setHours(12, 0, 0, 0);

    for (let remaining = Math.max(0, days); remaining > 0; ) {
      date.setDate(date.getDate() + 1);

      if (date.getDay() === 6 && !includeSaturday) continue;
      if (date.getDay() === 0 && !includeSunday) continue;

      remaining -= 1;
    }

    return date;
  }
}

if (!customElements.get('expected-delivery')) {
  customElements.define('expected-delivery', ExpectedDelivery);
}
